import { TableComponent } from './reservation-map/table/table.component';
import {
  DynamicDirective,
  ReservationMapComponent,
} from './reservation-map/reservation-map.component';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LogoComponent } from './logo/logo.component';
import { IntroComponent } from './intro/intro.component';
import { BackgroundComponent } from './background/background.component';
import { RoutingButtonComponent } from './routing-button/routing-button.component';
import { FloatingRoutingButtonComponent } from './floating-routing-button/floating-routing-button.component';
import { CreateReservationComponent } from './create-reservation/create-reservation.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { SocialMediaWidgetsComponent } from './social-media-widgets/social-media-widgets.component';
import {MatSnackBarModule} from "@angular/material/snack-bar";
import {LazyLoadImagesComponent} from "./lazy-load-images/lazy-load-images.component";
import {MenuBarComponent} from "./menu-bar/menu-bar.component";
import {LanguagesPickerComponent} from "./laguages-picker/languages-picker.component";
import {LanguageButtonComponent} from "./laguages-picker/laguage-button/language-button.component";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {ConfirmDialogComponent} from "./confirm-dialog/confirm-dialog.component";
import { ParkingInfoComponent } from './parking-info/parking-info.component';
import { ClientMenuComponent } from './client-menu/client-menu.component';
import {MatDialogModule} from "@angular/material/dialog";
import {MatCheckboxModule} from "@angular/material/checkbox";
import { GardenOrRestuarantComponent } from './create-reservation/garden-or-restuarant/garden-or-restuarant.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    LogoComponent,
    IntroComponent,
    BackgroundComponent,
    RoutingButtonComponent,
    FloatingRoutingButtonComponent,
    CreateReservationComponent,
    ReservationMapComponent,
    TableComponent,
    DynamicDirective,
    SocialMediaWidgetsComponent,
    LazyLoadImagesComponent,
    MenuBarComponent,
    LanguagesPickerComponent,
    LanguageButtonComponent,
    ConfirmDialogComponent,
    ParkingInfoComponent,
    ClientMenuComponent,
    GardenOrRestuarantComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    MatButtonModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    ReactiveFormsModule,
    MatIconModule,
    MatProgressBarModule,
    MatSnackBarModule,
    MatAutocompleteModule,
    MatDialogModule,
    MatCheckboxModule,
    TranslateModule,
  ],
    exports: [
        LogoComponent,
        IntroComponent,
        BackgroundComponent,
        RoutingButtonComponent,
        FloatingRoutingButtonComponent,
        CreateReservationComponent,
        ReservationMapComponent,
        TableComponent,
        DynamicDirective,
        SocialMediaWidgetsComponent,
        LazyLoadImagesComponent,
        MenuBarComponent,
        GardenOrRestuarantComponent,
        TranslateModule,
    ],
})
export class SharedModule {}
